import { useState } from "react";
import { auth } from "../lib/firebase";
import { useAuth } from "../lib/auth";
import { useCallableAction } from "../hooks/useCallableAction";
import { ErrorNote } from "../components";

/**
 * İLK KURULUM — sistemde hiç iş sahibi yokken görünen tek ekran.
 *
 * Oturum açmış ama rolü olmayan kullanıcıya gösterilir. `bootstrapFirstBoss`
 * çağrısı sistemde bir `boss` varsa kalıcı olarak reddedilir; yani bu ekran
 * yalnızca bir kez işe yarar ve sonrasında ölü bir sayfaya dönüşür.
 */
export function Setup() {
  const { signOut } = useAuth();
  const [done, setDone] = useState(false);

  const bootstrap = useCallableAction<
    Record<string, never>,
    { uid: string; role: string; seededCount: number; message: string }
  >("bootstrapFirstBoss");

  async function run() {
    const res = await bootstrap.run({});
    if (res) setDone(true);
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center px-4 py-12">
      <div className="card card-pad">
        <h1 className="text-xl font-semibold text-gray-900">Balder — İlk Kurulum</h1>

        <p className="mt-2 text-sm text-gray-600">
          Hesabınız (<strong>{auth.currentUser?.email}</strong>) henüz bir role sahip değil.
          Sistemde hiç iş sahibi tanımlı değilse bu adımda kendinizi iş sahibi olarak
          atayabilir ve referans verilerini (statü sözlüğü, kategoriler, finans
          parametreleri) yükleyebilirsiniz.
        </p>

        {done ? (
          <div className="mt-5 rounded-md border border-green-300 bg-green-50 px-4 py-3 text-sm text-green-900">
            <p className="font-medium">Kurulum tamamlandı.</p>
            <p className="mt-1">
              {bootstrap.result?.message ??
                "Yetkinin geçerli olması için çıkış yapıp tekrar giriş yapın."}
            </p>
            <button
              type="button"
              onClick={() => void signOut()}
              className="btn btn-primary mt-3"
            >
              Çıkış yap ve tekrar giriş yap
            </button>
          </div>
        ) : (
          <>
            <ErrorNote error={bootstrap.error} className="mt-4" />

            <button
              type="button"
              onClick={() => void run()}
              disabled={bootstrap.loading}
              className="btn btn-primary mt-5 w-full"
            >
              {bootstrap.loading ? "Kuruluyor…" : "Beni iş sahibi olarak ata"}
            </button>

            <p className="mt-4 text-xs text-gray-500">
              Sistemde zaten bir iş sahibi varsa bu işlem reddedilir. O durumda
              hesabınıza rol atanması için iş sahibiyle görüşün.
            </p>
          </>
        )}

        <button
          type="button"
          onClick={() => void signOut()}
          className="mt-6 text-sm text-gray-500 underline hover:text-gray-700"
        >
          Çıkış yap
        </button>
      </div>
    </div>
  );
}

export default Setup;
